export const linkTypes = {
  tag: "TAG",
  ticket: "TICKET",
  no_reference: "NO_REFERENCE",
};
export class SignUpCredentials {
  instanceId = null
  link = {
    registerType: null,
    registerValue: null,
    authType: null,
    authValue: null
  };

  constructor(instanceId, registerType, registerValue, authType, authValue) {
    this.instanceId = instanceId
    this.link.registerType = registerType
    this.link.registerValue = registerValue
    this.link.authType = authType
    this.link.authValue = authValue
  }

  toJSON() {
    return {
      instanceId: this.instanceId,
      link: {
        registerType: this.link.registerType,
        registerValue: this.link.registerValue,
        authType: this.link.authType,
        authValue: this.link.authValue
      },
      locale:
        (navigator.language || navigator.userLanguage).split("-")[0] === "es"
          ? "es"
          : (navigator.language || navigator.userLanguage).split("-")[0] ===
            "sv"
          ? "sv"
          : (navigator.language || navigator.userLanguage).split("-")[0] ===
            "pt"
          ? "pt"
          : "en",
    };
  }
}
